

import { forwardRef, useContext, useMemo } from 'react';

import { css, cx } from '@/styled-system/css';

import { Spinner } from '../spinner/spinner';
import { ButtonRootContext } from './context/button-root.context';
import { buttonLoadingRecipe } from './styles/button-loading.styles';
import type { ButtonLoadingPropsInterface } from './types/button-loading.types';

/**
 * @since 10.0.0
 */
export const ButtonLoading = forwardRef<HTMLSpanElement, ButtonLoadingPropsInterface>(
  (props, forwardedRef) => {
    const {
      tone = 'brand',
      emphasis = 'outlined',
      size = 'md',
      onImpact = false,
    } = useContext(ButtonRootContext);
    const { className } = props;

    const styles = css(buttonLoadingRecipe.raw());

    const isInverted = useMemo(() => {
      return onImpact
        ? emphasis !== 'filled'
        : (tone === 'brand' || tone === 'critical') && emphasis === 'filled';
    }, [onImpact, tone, emphasis]);

    const spinnerSize = useMemo(() => {
      return size === 'sm' ? 'sm' : 'md';
    }, [size]);

    return (
      <span
        ref={forwardedRef}
        data-c11n-component="Button.Loading"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', 'group', styles, className)}
      >
        <Spinner size={spinnerSize} onImpact={isInverted} />
      </span>
    );
  },
);

ButtonLoading.displayName = 'Button.Loading';
